import script from "./JobIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./JobIndex.vue?vue&type=script&setup=true&lang=js"

import "./JobIndex.vue?vue&type=style&index=0&id=f236a47c&lang=css"
import "./JobIndex.vue?vue&type=style&index=1&id=f236a47c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f236a47c"]])

export default __exports__